<template>
  <div id="app" :class="theme" v-cloak>
    <Header />
    <transition name="el-fade-in" mode="out-in">
      <router-view v-if="refreshActive" />
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Header from "@/components/public/Header";
import AddRouterFunc from "@/router/addRouter";

export default {
  name: "App",
  props: [],
  components: {
    Header
  },
  data() {
    return {
      // 点击当前连接刷新
      refreshActive: true
    };
  },
  computed: {
    ...mapGetters(["userToken", "userData", "theme", "accessToken"])
  },
  created() {
    // 接口返回拦截
    this.$http.interceptors.response.use(
      response => {
        if (response.data.resCode == 601) {
          this.logout();
        } else if (
          response.data.resCode == 0 ||
          response.data.resCode == -1003 ||
          response.data.token_type === "bearer"
        ) {
        } else if (
          response.headers["content-type"] ===
          "application/octet-stream;charset=utf-8"
        ) {
          // 判断文件流
        } else {
          this.$message.error(response.data.resMsg);
        }
        return response;
      },
      error => {
        if (error.response) {
          switch (error.response.status) {
            case 401:
              // 登录超时
              this.logout();
              break;
            case 402:
              // keycloak的刷新token过期会返回402，刷新页面重新请求一次新accessToken
              window.location.reload();
              break;
            case 403:
              // 登录超时
              this.$message.error("权限不足，请联系管理员");
              break;
            default:
              // this.logout();
              this.$message.error(error.response.data.message);
          }
        }
        return Promise.reject(error.response.data);
      }
    );

    if (this.userToken) {
      this.$http.defaults.headers.common["token"] = this.userToken;
      this.fetchUserData();
    } else {
      this.$router.push({
        name: "login"
      });
    }
  },
  mounted() {
    // 从keycloak改回hall需要修改的页面
    // 1、main.js中注释掉keyclo引用
    // 2、routerData中将office中的 '@/views/office/Office.vue' 改为 '@/views/office/OfficeForHall.vue'
  },
  destroyed() {},
  methods: {
    ...mapActions(["setUserData", "logout", "setUserToken"]),
    async fetchUserData() {
      const loading = this.$loading({
        lock: true,
        text: "正在加载，请稍后",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$http
        .all([this.getUserInfo(), this.getPermissionMenu()])
        .then(
          this.$http.spread((userInfo, routerData) => {
            if (userInfo.data.resCode != 0) {
              setTimeout(() => {
                this.logout();
              }, 2000);
            } else if (routerData.data.resCode != 0) {
              setTimeout(() => {
                this.logout();
              }, 2000);
            } else {
              this.setUserData({
                ...userInfo.data.resData,
                routerData: [...routerData.data.resData, "/test"]
              });

              this.$nextTick(() => {
                loading.close();
                this.addRouter();
              });
            }
          })
        )
        .catch(() => {
          this.logout();
        });
    },
    async getUserInfo() {
      return this.$http.get("/web/getUserInfo");
    },
    async getPermissionMenu() {
      return this.$http.get("/menu/getPermissionMenu");
    },
    addRouter() {
      const routerData = AddRouterFunc.getNewRouerData(
        this.userData.routerData
      );
      this.$router.addRoutes(routerData);
    },
    refresh() {
      this.refreshActive = false;
      this.$nextTick(() => {
        this.refreshActive = true;
      });
    }
  },
  watch: {
    userToken(value) {
      if (!value) {
        window.location.reload();
      }
    }
  },
  filters: {}
};
</script>

<style scoped>
</style>